import React, { Component, Fragment } from 'react'
import { NavLink } from "react-router-dom";
import { IsAuthorize } from '../../shared/authorization/check-access';
import { Role } from '../../shared/authorization/enums';

interface IProps {
    id: number,
    url: string
}
export default class AccountTabs extends Component<IProps> {
    render() {
        return (
            <Fragment>
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                {IsAuthorize([Role.TAM, Role.Dev,Role.AM, Role.Support ,Role.Manager]) &&  <li className="nav-item">
                        <NavLink to={"/account/account-form/" + this.props.id} className={this.props.url == "/account/account-form/" ? "nav-link active" : "nav-link"} id="edit-tab" data-toggle="tab" href="#edit" role="tab"
                            aria-controls="edit" aria-selected={this.props.url == "/account/account-form/" ? "true" : "false"}><i className="far fa-edit"></i>&nbsp;Edit</NavLink>
                    </li> }
                    {IsAuthorize([Role.Sales, Role.AM, Role.TAM, Role.Dev, Role.Support ,Role.Manager, Role.AdminViewer]) && <li className="nav-item">
                        <NavLink to={"/account/detail/" + this.props.id} className={this.props.url == "/account/detail/" ? "nav-link active" : "nav-link"} id="show-tab" data-toggle="tab" href="#show" role="tab"
                            aria-controls="show" aria-selected={this.props.url == "/account/detail/" ? "true" : "false"}><i className="fas fa-info-circle"></i>&nbsp;Show</NavLink>
                    </li>}

                    <li className="nav-item">
                        <NavLink to={"/account/connections/" + this.props.id} className={this.props.url == "/account/connections/" ? "nav-link active" : "nav-link"} id="show-tab" data-toggle="tab" href="#connections" role="tab"
                            aria-controls="connections" aria-selected={this.props.url == "/account/connections/" ? "true" : "false"}><i className="fas fa-share"></i>&nbsp;Connections</NavLink>
                    </li>

                    <li className="nav-item">
                        <NavLink to={"/account/sources/" + this.props.id} className={this.props.url == "/account/sources/" ? "nav-link active" : "nav-link"} id="show-tab" data-toggle="tab" href="#sources" role="tab"
                            aria-controls="sources" aria-selected={this.props.url == "/account/sources/" ? "true" : "false"}><i className="fas fa-retweet"></i>&nbsp;Sources</NavLink>
                    </li>

                    <li className="nav-item">
                        <NavLink to={"/account/installed-apps/" + this.props.id} className={this.props.url == "/account/installed-apps/" ? "nav-link active" : "nav-link"} id="show-tab" data-toggle="tab" href="#installed-apps" role="tab"
                            aria-controls="installed-apps" aria-selected={this.props.url == "/account/installed-apps/" ? "true" : "false"}><i className="fas fa-server"></i>&nbsp;Installed Apps</NavLink>
                    </li>

                    <li className="nav-item">
                        <NavLink to={"/account/data-engine-jobs/" + this.props.id} className={this.props.url == "/account/data-engine-jobs/" ? "nav-link active" : "nav-link"} id="show-tab" data-toggle="tab" href="#data-engine-jobs" role="tab"
                            aria-controls="data-engine-jobs" aria-selected={this.props.url == "/account/data-engine-jobs/" ? "true" : "false"}><i className="fas fa-align-justify"></i>&nbsp;Current Data Engine Jobs</NavLink>
                    </li>
                </ul>
                <br />
            </Fragment>
        )
    }
}
